import { render, staticRenderFns } from "./jilu.vue?vue&type=template&id=132143c9&"
import script from "./jilu.vue?vue&type=script&lang=js&"
export * from "./jilu.vue?vue&type=script&lang=js&"
import style0 from "./jilu.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports